<template>
    <b-modal
        id="edit-slu-cohort-modal"
        v-model="modal"
        ref="edit-slu-cohort-modal"
        size="lg"
        :title="$t('slu_dashboard.edit_grade')"
        modal-class="apprentice-default-modal add-slu-cohort"
        :ok-title="$t('common.save')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <div class="update-slu-cohort">
            <div class="errors">
                <b-alert
                    v-if="hasError"
                    variant="danger"
                    show>
                    {{ $t('slu_dashboard.name_cannot_be_empty') }}
                </b-alert>
            </div>

            <b-form-group
                class="slu-cohort-name"
                label-for="slu-cohort-name-input"
                :label="$t('common.name')">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span></template>
                <b-form-input
                    id="slu-cohort-name-input"
                    v-model="name"
                    :placeholder="$t('slu_dashboard.grade_name')">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="slu-cohort-target"
                label-for="slu-cohort-target-input"
                label="target">
                <template v-slot:label>
                    {{ $t('slu_dashboard.minimum_percentage', { points_name: sluSchoolSettingsIn.name_points }) }}:
                    <span class="required">*</span>
                </template>
                <b-form-input
                    id="slu-cohort-target-input"
                    v-model="target"
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    :placeholder="
                        $t('slu_dashboard.minimum_percentage', { points_name: sluSchoolSettingsIn.name_points })
                    "
                    @blur="convertToInteger">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="slu-cohort-season"
                label-for="slu-cohort-season-input"
                :label="$t('slu_dashboard.season')">
                <b-form-select
                    class="apprentice-primary-select slu-cohort-season-select"
                    id="slu-cohort-season-input"
                    v-model="season"
                    v-if="seasonsIn.length"
                    :options="seasonsIn"
                    text-field="season"
                    value-field="id">
                </b-form-select>
            </b-form-group>

            <div
                class="stdc-sync-status"
                v-if="sluSchoolSettingsIn.stc_sync">
                <b-form-group
                    class="sync-with-std-group"
                    label-for="sync-with std-button"
                    :label="$t('slu_dashboard.connected_with_somtoday')">
                    <b-badge
                        class="badge-std-sync"
                        :variant="stcCourseUuid !== null ? 'success' : 'danger'">
                        {{ stcCourseUuid !== null ? $t('common.yes') : $t('common.no') }}
                    </b-badge>
                </b-form-group>

                <b-button
                    class="btn-sync-stdc"
                    variant="primary"
                    @click="openSomTodayConnectModal">
                    <i class="btn-chain-link"></i>{{ $t('slu_dashboard.connect_to_somtoday') }}
                </b-button>

                <design-2021-slu-som-today-connect-course-modal-component
                    :slu-cohort-in="cohort"
                    ref="select-stc-course-uuid"
                    @updateStcCourseUuid="updateStcCourseUuid($event)">
                </design-2021-slu-som-today-connect-course-modal-component>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-update-slu-cohort-modal-component',
    props: ['seasonsIn', 'sluCourseIn', 'sluSchoolSettingsIn'],
    data() {
        return {
            name: '',
            cohort: null,
            seasons: this.seasonsIn.reverse(),
            season: null,
            stcCourseUuid: null,
            modal: false,
            sluSomTodayConnect: true,
            target: 0,
            hasError: false,
        };
    },
    methods: {
        onOk(bvModal) {
            this.hasError = false;

            if (this.name === null || this.name === '') {
                this.hasError = true;
                bvModal.preventDefault();
                return;
            }

            let data = {
                name: this.name,
                seasonId: this.season,
                cohortId: this.cohort.id,
                stcCourseUuid: this.stcCourseUuid,
                target: this.target,
            };

            this.alert.saving();

            this.axios.post(this.routes.sluCohortUpdate(this.sluCourseIn.id), data).then(
                (response) => {
                    this.$emit('updateCohorts', response.data);
                    this.alert.success();
                },
                (error) => {
                    return this.alert.ajaxError(error);
                },
            );
        },

        show(data) {
            this.cohort = data;
            this.name = data.name;
            this.season = data.season.id;
            this.target = data.target;
            if (this.sluSomTodayConnect) {
                this.stcCourseUuid = data.stc_course_uuid;
            }
            this.modal = true;
        },
        openSomTodayConnectModal() {
            if (this.cohort.users && this.cohort.users.length === 0) {
                this.alert.notice(
                    this.$t('slu_dashboard.failed_to_retrieve_data'),
                    this.$t('slu_dashboard.no_students_found_for_this_grade'),
                    'warning',
                );
                return;
            }

            this.$refs['select-stc-course-uuid'].show();
        },
        updateStcCourseUuid(stcCourseUuid) {
            this.stcCourseUuid = stcCourseUuid.uuid;
        },
        convertToInteger() {
            this.target = parseInt(this.target);
        },
    },
};
</script>

<style scoped lang="scss">
.update-slu-cohort {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    align-content: flex-start;
    column-gap: $grid-gutter-width;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');

    input,
    select {
        margin-bottom: 0;
    }

    select {
        width: 100%;
    }

    .errors {
        flex: 1 0 100%;
    }

    .form-group {
        margin-bottom: 0;
        width: 100%;
    }

    .slu-cohort-season {
        align-self: flex-start;
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .update-slu-cohort {
        .form-group {
            width: auto;
        }
    }

    .slu-cohort-name {
        flex: 1 1 calc(50% - 15px);
    }

    .slu-cohort-target {
        flex: 0 1 calc(30% - 15px);
    }

    .slu-cohort-season {
        flex: 0 1 calc(18% - 15px);
    }
}

.sync-with-std-group,
.btn-sync-stdc {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.sync-with-std-group ::v-deep {
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    label {
        margin-bottom: 0;
    }

    .badge-std-sync {
        color: $white;
        font-size: $base-font-size;
        font-weight: $font-weight-normal;
    }
}

.btn-sync-stdc {
    column-gap: map-get($grid-gutter-spacing, 'eight');
    margin-top: map-get($grid-gutter-spacing, 'fifteen');

    i {
        font-style: normal;
        color: $white;
    }
}

.stdc-sync-status {
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
}
</style>
